import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminService } from '../../services/adminService';

const RolesList = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [total, setTotal] = useState(0);
  const [dialogConfirmacao, setDialogConfirmacao] = useState({ open: false, role: null });

  useEffect(() => {
    carregarRoles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagina]);

  const carregarRoles = async () => {
    setLoading(true);
    setError('');
    try {
      const dados = await adminService.listarRoles(pagina, 50);
      setRoles(dados.roles || []);
      setTotalPaginas(dados.paginacao?.total_paginas || 1);
      setTotal(dados.paginacao?.total || 0);
    } catch (err) {
      setError(err.message || 'Erro ao carregar roles');
      setRoles([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = (role) => {
    setDialogConfirmacao({ open: true, role });
  };

  const confirmarExclusao = async () => {
    try {
      await adminService.excluirRole(dialogConfirmacao.role.id);
      setDialogConfirmacao({ open: false, role: null });
      carregarRoles();
    } catch (err) {
      setError(err.message || 'Erro ao excluir role');
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          Gestão de Roles
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/admin/roles/criar')}
        >
          Criar Role
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Paper sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Nome</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Descrição</TableCell>
                    <TableCell sx={{ fontWeight: 700 }} align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roles.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                        <Typography color="text.secondary">
                          Nenhuma role encontrada
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    roles.map((role) => (
                      <TableRow key={role.id} hover>
                        <TableCell>{role.id}</TableCell>
                        <TableCell>{role.nome}</TableCell>
                        <TableCell>{role.descricao}</TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => navigate(`/admin/roles/editar/${role.id}`)}
                              title="Editar"
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleExcluir(role)}
                              title="Excluir"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {totalPaginas > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Pagination
                  count={totalPaginas}
                  page={pagina}
                  onChange={(e, value) => setPagina(value)}
                  color="primary"
                />
              </Box>
            )}

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
              Total: {total} role(s)
            </Typography>
          </>
        )}
      </Paper>

      {/* Dialog de Confirmação */}
      <Dialog open={dialogConfirmacao.open} onClose={() => setDialogConfirmacao({ open: false, role: null })}>
        <DialogTitle>Excluir Role</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente excluir a role "{dialogConfirmacao.role?.nome}"? Esta ação não pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogConfirmacao({ open: false, role: null })}>
            Cancelar
          </Button>
          <Button onClick={confirmarExclusao} color="error" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RolesList;




